<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="layout">
    <NavbarBack
      @backButtonClicked="backButtonClicked"
      v-if="hasToShowOldMenu"
      :title="titlePage"
      :back="backPage"
      :additionalLinksMobile="additionalLinksMobile"
    />
    <Notification v-if="notification.show" />
    <slot></slot>
    <ModalChangesUnsaved />
  </div>
</template>

<script>
import ModalChangesUnsaved from '@/components/Shared/ModalChangesUnsaved.vue'
import NavbarBack from './parts/NavbarBack'
import Notification from './parts/Notification'

const API_LEGACY_URL = process.env.VUE_APP_API_LEGACY_URL

export default {
  components: {
    NavbarBack,
    Notification,
    ModalChangesUnsaved,
  },

  props: {
    titlePage: {
      type: String,
      default: 'Área logada',
    },

    route: {
      type: Object,
    },

    additionalLinksMobile: {
      type: Array,
    },
  },

  computed: {
    hasToShowOldMenu() {
      if (!this.$store.state.app.wedSiteInfo) {
        // wait wedsite data to be available
        return false
      }

      const routeName = this.$route.name
      if (routeName === 'customizacao-do-tema') {
        return true
      }

      return this.$store.state.app.wedSiteInfo.site_menu_versao ? false : true
    },
    rightButtonLabel() {
      return 'Ajuda'
    },
    notification() {
      return this.$store.state.app.notification
    },
  },

  methods: {
    backPage() {
      if (!this.route) location.href = API_LEGACY_URL + '/go/dadosdosite'
      else if (this.route.external) location.href = this.route.external
      else if (this.route.passive) this.$emit('backButtonClicked')
      else this.$router.push(this.route)
    },

    backButtonClicked() {
      this.$emit('backButtonClicked')
    },
  },
}
</script>

<style lang="scss">
.layout {
  &__content {
    padding-top: 70px;
    display: flex;

    &--max-width {
      width: 100%;
    }
  }
}

@media (min-width: $tablet) {
  .columns--full {
    min-height: calc(100vh - 60px);
  }
  .c-base-header-page--full {
    height: calc(80vh - 60px) !important;
  }
}

.new-menu {
  @media (min-width: $tablet) {
    .columns--full {
      min-height: auto !important;
    }
    .c-base-header-page--full {
      min-height: calc(80vh - 60px);
      height: auto !important;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
